import { render } from "./SegmentationBlockAND.vue?vue&type=template&id=79d1b1e4&scoped=true"
import script from "./SegmentationBlockAND.vue?vue&type=script&lang=ts"
export * from "./SegmentationBlockAND.vue?vue&type=script&lang=ts"

import "./SegmentationBlockAND.vue?vue&type=style&index=0&id=79d1b1e4&lang=scss&scoped=true"
import "./SegmentationBlockAND.vue?vue&type=style&index=1&id=79d1b1e4&lang=scss"
script.render = render
script.__scopeId = "data-v-79d1b1e4"

export default script